// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.core--summary-empty span{color:gray}`, "",{"version":3,"sources":["webpack://./src/common-client2/src/components/SummaryEmpty/SummaryEmpty.scss"],"names":[],"mappings":"AACI,0BACI,UAAA","sourcesContent":[".core--summary-empty {\r\n    span {\r\n        color: gray;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
